import { Unidade } from 'model/reino/Unidade';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { UnidadesResponsaveisSelector } from 'store/UnidadesResponsaveis/UnidadesResponsaveis.selector';
import Avatar from '../Avatar/Avatar';

interface AvatarUnidadeProps {
  unidade: Unidade;
}

export const AvatarUnidade: FC<AvatarUnidadeProps> = ({unidade}) => {
  return <Avatar aria-hidden={true} iniciais={unidade.sigla} />
}

interface AvatarUnidadeByIdProps {
  idUnidade: number;
}

export const AvatarUnidadeById: FC<AvatarUnidadeByIdProps> = ({idUnidade}) => {
  const unidade = useSelector(UnidadesResponsaveisSelector.unidade(idUnidade));
  const isCarregando = useSelector(UnidadesResponsaveisSelector.isCarregando);
  
  return <Avatar loading={isCarregando} aria-hidden={true} iniciais={unidade?.sigla ?? ''} />
}